module.exports = __webpack_public_path__ + "static/9-d4397857def69685dd74e94b6897271f.jpg";